/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_OtherInputs */

const en_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const es_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const fr_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const de_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstige`)
};

const ja_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他`)
};

const zh_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const ar_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أخرى`)
};

const id_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lainnya`)
};

const it_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

const ru_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другое`)
};

const pt_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const ko_val_other = /** @type {(inputs: Val_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기타`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Val_OtherInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_other = /** @type {((inputs?: Val_OtherInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_OtherInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_other(inputs)
	if (locale === "es") return es_val_other(inputs)
	if (locale === "fr") return fr_val_other(inputs)
	if (locale === "de") return de_val_other(inputs)
	if (locale === "ja") return ja_val_other(inputs)
	if (locale === "zh") return zh_val_other(inputs)
	if (locale === "ar") return ar_val_other(inputs)
	if (locale === "id") return id_val_other(inputs)
	if (locale === "it") return it_val_other(inputs)
	if (locale === "ru") return ru_val_other(inputs)
	if (locale === "pt") return pt_val_other(inputs)
	return ko_val_other(inputs)
});